import React, {useState, useRef} from 'react';
import JoditEditor from "jodit-react";

const Editor = ({name, content, afterChange}) => {
	const editor = useRef(null);
	
	const config = {
    readonly: false,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: "insert_as_html",
    buttons: "source,|,bold,underline,italic,|,ul,ol,|,link,align,undo,redo,cut,copy,paste,|,symbol,"
	}
	
	return (
    <JoditEditor
      ref={editor}
        value={content}
        config={config}
        tabIndex={1}
        onChange={newContent => {afterChange(name, newContent)}}
        name={name}
    />
  );
}

export default Editor;